import { useContext } from 'react';
import { SearchContext } from './types';
import type { GlobalSearchContext } from './types';

export const useGlobalSearch = (): GlobalSearchContext => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useGlobalSearch must be used within SearchProvider');
  }
  return context;
};